import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-box" }
const _hoisted_2 = { class: "pw-player-seekbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "pw-player-button pw-duration",
      innerHTML: _ctx.durationString.value,
      style: { width: _ctx.durationWidth }
    }, null, 12, ["innerHTML"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("input", {
        type: "range",
        step: "any",
        min: "0",
        max: "100",
        "aria-label": `${_ctx.translateLabels('Seek')}`,
        ref: "shakaSeeker",
        style: _ctx.seekbarCss.value
      }, null, 12, ["aria-label"])
    ]),
    _createVNode("div", {
      class: "pw-player-button pw-duration",
      ref: "totalDurationElm",
      innerHTML: _ctx.totalDurationString.value
    }, null, 8, ["innerHTML"])
  ]))
}